import { TeamsResponse, baseTeamMemberInvitePayload, createTeamsPayload, updateTeamsPayload } from '../features/location/locationTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_locations = '/{0}/location.list';
const create_locations = '/{0}/location.add';
const delete_teams = '/team/{0}/{1}/deleteTeam';
const update_location = '/{0}/location.update';
const fetch_locations_status = '/{0}/location.list';
const fetch_location = '/location.locationsList';

const credentialsConfig = {
  withCredentials: true,
}


export const fetchLocationData = async (baseId: number): Promise<TeamsResponse> => {
  const fetch_location_data = formatUrl(fetch_locations, [baseId]);
  return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};

// export const fetchLocationDataStatus = async (baseId: number, status?: string): Promise<TeamsResponse> => {
//   let fetch_location_data = formatUrl(fetch_locations_status, [baseId]);
//   if (status) {
//     fetch_location_data += `?status=${status}`;
//   }
//   return get<TeamsResponse>(fetch_location_data, credentialsConfig);
// };


export const fetchLocationDataStatus = async (baseId: number, status?: string): Promise<TeamsResponse> => {
  let fetch_location_data = formatUrl(fetch_locations_status, [baseId]);
  if (status) {
    fetch_location_data += `?status=${status}`;
  }
  return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};




export const createLoationData = async (data: createTeamsPayload, userId: number): Promise<TeamsResponse> => {
  const base_create_location = formatUrl(create_locations, [userId]);
  return post<TeamsResponse>(base_create_location, data, credentialsConfig);
};

export const deleteTeamsData = async (id: number, baseId: number): Promise<TeamsResponse> => {
  const delete_teams_data = formatUrl(delete_teams, [baseId, id]);
  return del<TeamsResponse>(delete_teams_data, credentialsConfig);
};


export const updateLocationData = async ( baseId: number, data: updateTeamsPayload): Promise<TeamsResponse> => {
  const update_teams_data = formatUrl(update_location, [baseId]);
  return put<TeamsResponse>(update_teams_data, data, credentialsConfig);
};


export const fetchLocationBySearch = async (searchQuery: string): Promise<TeamsResponse> => {
  const url = `/location.locationsList?search=${encodeURIComponent(searchQuery)}`;
  return get<TeamsResponse>(url, { withCredentials: true });
};